import $ from 'jquery';
import 'slick-carousel';

$('#providers-slider').slick({
    infinite: true,
    autoplay: false,
    dots: false,
    slidesToShow: 7,
    slidesToScroll: 7,
    prevArrow:
        "<button type='button' class='arrow-prev pull-left mr-2 arrow-style'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:
        "<button type='button' class='arrow-next pull-right arrow-style'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    appendArrows: $('.providers-arrows'),
    touchThreshold: 1000,
    responsive: [
        {
            breakpoint: 1050,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
            },
        },
    ],
});
